/**
 * A keyframe contact sheet (one still per scene, laid out by the backend: 6 columns for portrait videos, 4 for
 * landscape, scenes numbered under each still) — click a still to jump to that scene.
 */
import type { MouseEvent } from 'react';

export function KeyframeSheet({ url, count, portrait, onPick, className }: { url: string; count: number; portrait: boolean; onPick?: (index: number) => void; className?: string }) {
  const cols = Math.max(1, Math.min(count, portrait ? 6 : 4));
  const rows = Math.max(1, Math.ceil(count / cols));
  const pick = (e: MouseEvent<HTMLImageElement>) => {
    if (!onPick) return;
    const r = e.currentTarget.getBoundingClientRect();
    const col = Math.min(cols - 1, Math.floor(((e.clientX - r.left) / r.width) * cols));
    const row = Math.min(rows - 1, Math.floor(((e.clientY - r.top) / r.height) * rows));
    const i = row * cols + col;
    if (i < count) onPick(i);
  };
  return <img src={url} alt="Keyframes, one still per scene" onClick={pick} title={onPick ? 'Click a still to go to that scene' : undefined} className={`${onPick ? 'cursor-pointer' : ''} ${className || ''}`} />;
}
